import "../scss/styles.scss";
// Default js file. You can add the plugins in the /vendors folder
(function($) {

    "use strict";

    var HAVAS = HAVAS || {};

    HAVAS.Miscellaneous = {
        init: function(){
            this.binds(); // Binds
        },
        el: {
            $navCt: $('.nav-contact').find('a'),
            $toggleMobile: $('.menu-btn')
        },
        binds: function() {
            var _this = this;
            
            this.el.$navCt.on('click', function(e) {
                e.preventDefault();
                $("html, body").animate({ scrollTop: $(document).height() }, 1000, 'swing');
            });
            this.el.$toggleMobile.on('click', function(e) {
                e.preventDefault();
                $("#sidebar").toggleClass('opened');
            });

            $('.open-fancybox').fancybox({
                hideScrollbar: false
            });
        }
    }

    HAVAS.init = function() {
        HAVAS.Miscellaneous.init();
    };

    HAVAS.init();    

})(jQuery);